import {
  useSwingLibrarySettings,
  useUpdateSwingLibrarySettings,
} from "../hooks/useSwingLibrarySettings";
import { Toggle } from "../../../components/shared/Toggle/Toggle";
import Button from "../../../components/shared/Button/Button";
import { HorizontalScrollWrapper } from "../../../components/shared/HorizontalScrollWrapper/HorizontalScrollWrapper";
import { HiPlus } from "react-icons/hi";
import { useMediaQuery } from "@material-ui/core";
import { IoClose } from "react-icons/io5";

const IndicatorsRow = ({
  setIsIndicatorFilterOpen,
  showTourAverages = true,
}) => {
  const { data: swingLibrarySettings } = useSwingLibrarySettings();
  const updateSwingLibrarySettings = useUpdateSwingLibrarySettings();

  const isXl = useMediaQuery("(min-width: 1280px)");

  const toggleTourAverages = async () => {
    await updateSwingLibrarySettings.mutateAsync({
      tourAveragesToggle: !swingLibrarySettings?.tourAveragesToggle,
    });
  };

  const handleIndicatorClear = async () => {
    await updateSwingLibrarySettings.mutateAsync({ savedIndicators: [] });
  };

  const handleSingleIndicatorRemove = async (indicator) => {
    const newData = swingLibrarySettings?.savedIndicators?.filter(
      (fl) => fl.id !== indicator.id
    );
    await updateSwingLibrarySettings.mutateAsync({ savedIndicators: newData });
  };

  return (
    <>
      {showTourAverages && (
        <>
          <div className="flex items-center gap-2">
            <span className="text-sm font-semibold">Tour Averages</span>
            <Toggle
              isChecked={!!swingLibrarySettings?.tourAveragesToggle}
              onChange={toggleTourAverages}
            />
          </div>
          <div className="border-gray300 h-6 border-r-0 border-l" />
        </>
      )}

      <Button
        className={`flex flex-row items-center gap-2 text-sm ${
          isXl ? "min-w-[70px] px-3 py-1" : "min-w-[80px] p-2"
        }`}
        color="primary50"
        onClick={() => setIsIndicatorFilterOpen(true)}
        rounded="full"
        size="xxs"
      >
        Add data
        {isXl ? <HiPlus className="text-primary500 size-4" /> : null}
      </Button>

      <button
        className={`text-error700 text-sm ${
          isXl ? "min-w-[70px] px-3 py-1" : "min-w-[80px] p-2"
        }`}
        onClick={handleIndicatorClear}
      >
        Remove all
      </button>

      <div className="border-gray300 h-6 border-r-0 border-l" />

      {swingLibrarySettings &&
        swingLibrarySettings?.savedIndicators?.length > 0 && (
          <HorizontalScrollWrapper
            style={{
              flex: 1,
              minWidth: 0,
              width: "auto",
            }}
          >
            {swingLibrarySettings?.savedIndicators?.map((indicator) => (
              <div
                className="bg-gray100 flex items-center gap-1 rounded-full px-2 py-1 whitespace-nowrap"
                key={indicator.id}
              >
                <div className="text-gray700 text-sm">
                  {indicator?.name?.charAt(0).toUpperCase() +
                    indicator?.name?.slice(1)}
                </div>
                <IoClose
                  className="text-gray500 size-4 cursor-pointer"
                  onClick={() => handleSingleIndicatorRemove(indicator)}
                />
              </div>
            ))}
          </HorizontalScrollWrapper>
        )}
    </>
  );
};

export default IndicatorsRow;
